import { Link, Outlet } from "react-router-dom";

const ConsultationManagement = () => (
  <div className="consultation-management">
    <h1>مدیریت درخواست های مشاوره</h1>
    <div className="consultation-management-actions">
      <Link to="list" className="consultation-management-button">
        لیست درخواست ها
      </Link>
      <Link to="add" className="consultation-management-button">
        افزودن درخواست
      </Link>
    </div>
    <div className="consultation-management-content">
      <Outlet />
    </div>
  </div>
);

export default ConsultationManagement;
